import request from '@/utils/request'

// 获取邀请码
export function getCodeImage(params) {
    return request({
        url: '/ycps/my/qrcode',
        method: 'get',
        params
    })
}

// 获取邀请奖励头部信息
export function getRewardCount(params){
    return request({
        url: '/ycps/reward/counts',
        method: 'get',
        params
    })
}

// 获取邀请列表
export function getInviteList(params){
    return request({
        url: '/ycps/reward/promotion',
        method: 'get',
        params
    })
}

// 获取奖励信息
export function rewardRule(params){
    return request({
        url: '/ycps/reward/scan',
        method: 'get',
        params
    })
}

// 拓客业绩各统计数 
export function performance(params){
    return request({
        url: '/ycps/reward/performance',
        method: 'get',
        params
    })
}

// 历史奖励查询 
export function historyReward(params){
    return request({
        url: '/ycps/reward/historyReward',
        method: 'get',
        params
    })
}

// 查看各门店值日状态 
export function myDetail(params){
    return request({
        url: '/ycps/my/detail',
        method: 'get',
        params
    })
}
